import ListingsRoutingResolver from './ListingRoutingResolver';

class OcrListingResolver extends ListingsRoutingResolver {
    constructor() {
        super();
        this.key = 'purchase.incoming';
    }
}

export default OcrListingResolver;
